"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fonts = void 0;
var fonts = exports.fonts = {
  buenosAires: "'Buenos Aires', Arial, sans-serif",
  nunito: "'Nunito', Arial, sans-serif"
};